import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/ru";

dayjs.extend(utc);
dayjs.extend(timezone);

import { DateType } from 'shared/types';

export const toDate = (date?: string | null, format?: string): DateType => {
    return dayjs(date || undefined, format).locale('ru');
};

